import { render, staticRenderFns } from "./AddMilestone.vue?vue&type=template&id=323846e2"
import script from "./AddMilestone.vue?vue&type=script&lang=js"
export * from "./AddMilestone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports